import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import { withProductRentalPlanHandler } from 'ggApp/shared/containers/product/detailedProductActions/productRentalPlan';

import {
    campaigns as campaignsSelector,
    currentProduct as currentProductSelector,
} from 'ggApp/modules/product/selectors';

import { viewPlanEventSender } from 'ggApp/shared/hocs/viewPlanEventSender';

import {
    rentalPlanIndexSelector,
    selectedRentalPlanSelector,
    currentProductRentalPlans as currentProductRentalPlansSelector,
} from '../../selectors';
import { withRentalPlanLabels, withRentalPlanSelectorPoints } from '../../hocs';
import { setRentalPlanIndex as setRentalPlanIndexAction } from '../../actions';
import Wrap, { RentalPlanSelectorWrapProps } from './Wrap';

const enhance = compose<RentalPlanSelectorWrapProps, {}>(
    connect(
        createStructuredSelector({
            currentProduct: currentProductSelector,
            rentalPlanIndex: rentalPlanIndexSelector,
            selectedPlan: selectedRentalPlanSelector,
            campaigns: campaignsSelector,
            rentalPlans: currentProductRentalPlansSelector,
        }),
        (dispatch) => ({
            setRentalPlanIndex: bindActionCreators(setRentalPlanIndexAction, dispatch),
        }),
    ),
    withRentalPlanLabels(currentProductSelector),
    withProductRentalPlanHandler,
    withRentalPlanSelectorPoints,
    viewPlanEventSender(),
);

export default enhance(Wrap);
